<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { userModule } from '@/store/user/module'
import UIKit from '@pocketprep/ui-kit'

const {
    Icon,
    Button: PocketButton,
} = UIKit

const props = withDefaults(
    defineProps<{
        title: string
        dismissableId: string
        confirmationText?: string
    }>(),
    { confirmationText: 'Got it!' }
)

const emit = defineEmits<{ close: [] }>()

const dismissed = ref(false)

const submitDismiss = () => {
    userModule.actions.dismiss(props.dismissableId)
    dismissed.value = true
    emit('close')
}

onMounted(() => {
    dismissed.value = userModule.getters.getDismissable(props.dismissableId) || false
})
</script>

<template>
    <div v-show="!dismissed" class="dismissable">
        <Icon
            class="dismissable__close"
            type="close"
            @click="submitDismiss"
        />
        <div v-if="props.title" class="dismissable__title">
            {{ props.title }}
        </div>
        <div class="dismissable__text">
            <slot />
        </div>
        <slot name="confirmation">
            <PocketButton
                class="dismissable__confirmation"
                type="tertiary"
                @click="submitDismiss"
            >
                {{ props.confirmationText }}
            </PocketButton>
        </slot>
    </div>
</template>

<style lang="scss" scoped>


.dismissable {
    position: relative;
    padding: 14px 12px 12px 13px;
    background-color: rgba($sky-blue, 0.3);
    border-radius: 5px;
    border: 1px solid rgba($brand-blue, 0.4);

    &__close {
        position: absolute;
        top: 14px;
        right: 12px;
        color: $pewter;
        cursor: pointer;

        &:hover {
            color: $brand-black;
        }
    }

    &__title {
        font-weight: 600;
        font-size: 15px;
        margin-bottom: 9px;
        line-height: 20px;
    }

    &__text {
        font-size: 14px;
        line-height: 19.12px;
        margin-bottom: 14px;
    }

    &__confirmation {
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 19px !important;
        padding-left: 0 !important;
    }
}
</style>
